import { getTotalPrice } from '@/lib/redux/features/cart';
import { useAppSelector } from '@/lib/redux/hooks';
import { useEffect, useState } from 'react';

const InvoicePrintAria = ({ printRef }: { printRef: any }) => {
  const cartItems = useAppSelector((state) => state.cart.items);
  const [isClient, setIsClient] = useState(false);
  const subtotal = getTotalPrice(cartItems);
  const discount = 15;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric', // 'numeric' or '2-digit'
    month: 'long', // 'long', 'short', 'numeric', or '2-digit'
    day: 'numeric', // 'numeric' or '2-digit'
  };

  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-GB', options);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null; // or a loading spinner
  }
  return (
    <div ref={printRef} className="row">
      <div className="col-lg-12">
        <div className="invoice__header">
          <div className="invoice__header-company">
            <div className="invoice__header-logo">
              <img src="/images/logo/logo-dark.png" alt="Logo" />
            </div>
            <h3>Dwyane Clark</h3>
            <p>24 Dummy Street Area, Location, Lorem Ipsum.</p>
          </div>
          <div className="invoice__header-info">
            <p>
              Issue Date: <strong>{formattedDate}</strong>
            </p>
            <p>
              Invoice No: <strong>6895874</strong>
            </p>
            <p>
              Email: <strong>user@gmail.com</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="invoice__table">
          <div className="table-responsive">
            <table className="table table-borderless align-middle">
              <thead>
                <tr className="order-table__header">
                  <th>SL</th>
                  <th>Item Name</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((data: any, i: number) => (
                  <tr key={i} className="order-table__row">
                    <td>{i + 1}</td>
                    <td>
                      <h4>{data.title}</h4>
                      <p>SKU: FQEW15KTK</p>
                    </td>
                    <td>{String(data.quantity).padStart(2, '0')}</td>
                    <td>${Number(data.price).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row justify-content-end">
        <div className="col-lg-4 col-md-5">
          <div className="invoice__total">
            <div className="invoice__total-data">
              <span>SubTotal</span>
              <span>${Number(subtotal).toFixed(2)}</span>
            </div>
            <div className="invoice__total-data">
              <span>Tax</span>
              <span>${Number(discount).toFixed(2)}</span>
            </div>
            <div className="invoice__total-data border-top">
              <span>Grand Total</span>
              <span>${Number(subtotal + discount).toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePrintAria;
